if (!customElements.get('scroll-carousel')) {
  customElements.define(
    'scroll-carousel',
    class ScrollCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        if (!this.track) return;

        this.prevButton = this.querySelector('[data-carousel-prev]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.update = this.update.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);

        this.prevButton?.addEventListener('click', () => this.scrollBySlide(-1));
        this.nextButton?.addEventListener('click', () => this.scrollBySlide(1));
        this.track.addEventListener('scroll', this.update, { passive: true });

        // También recalcula cuando el carrusel pasa de oculto a visible (pestañas)
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);

        document.addEventListener('shopify:block:select', this.onBlockSelect);
        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      get scrollBehavior() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }

      scrollBySlide(direction) {
        const slide = this.track.querySelector('[data-carousel-slide]');
        if (!slide) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (slide.getBoundingClientRect().width + gap), behavior: this.scrollBehavior });
      }

      onBlockSelect(event) {
        const slide = event.target.closest?.('[data-carousel-slide]');
        if (!slide || !this.track.contains(slide)) return;
        const offset = slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
        this.track.scrollTo({ left: this.track.scrollLeft + offset, behavior: this.scrollBehavior });
      }

      update() {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        this.classList.toggle('is-scrollable', maxScroll > 1);
        if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 1;
        if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 1;
      }
    }
  );
}
